export default __webpack_public_path__ + "d63324aee31c531bef1cebc5eb0217a8.png";